<template>
    <Modal 
        v-model="modal.visible" 
        :title="modalTitle"
        :mask-closable="false"
        :loading="modal.submitLoading"
        width="700"
        @on-cancel="handleModalCancel"
    >
        <Form 
            ref="companyForm"
            :model="modal.form" 
            :rules="modal.rules" 
            label-position="top"
        >
            <!-- 基本信息 -->
            <div class="form-section">
                <div class="section-title">
                    <Icon type="ios-business" size="16" color="#2d8cf0" />
                    <span>基本信息</span>
                </div>
                <Row :gutter="16">
                    
                    <!-- <Col :span="12">
                        <FormItem label="公司编码" prop="code">
                            <Input 
                                v-model="modal.form.code" 
                                placeholder="请输入公司编码"
                                :maxlength="50"
                                show-word-limit
                                :disabled="modal.isEdit"
                            >
                            </Input>
                        </FormItem>
                    </Col> -->
                    <Col :span="12">
                        <FormItem label="公司名称" prop="name">
                            <Input 
                                v-model="modal.form.name" 
                                placeholder="请输入公司名称"
                                :maxlength="100"
                                show-word-limit
                            >
                                <Icon type="ios-business" slot="prefix" />
                            </Input>
                        </FormItem>
                    </Col>
                </Row>
            </div>

            
            <!-- 其他信息 -->
            <div class="form-section">
                <div class="section-title">
                    <Icon type="ios-paper" size="16" color="#ed4014" />
                    <span>其他信息</span>
                </div>
                <Row :gutter="16">
                    <Col :span="12">
                        <FormItem label="状态" prop="status">
                            <RadioGroup v-model="modal.form.status" type="button">
                                <Radio label="1">
                                    <Icon type="ios-checkmark-circle" color="#19be6b" />
                                    启用
                                </Radio>
                                <Radio label="0">
                                    <Icon type="ios-close-circle" color="#ed4014" />
                                    禁用
                                </Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
            </div>
        </Form>
        <div slot="footer">
            <Button @click="handleModalCancel">取消</Button>
            <Button 
                type="primary" 
                @click="handleModalOk" 
                :loading="modal.submitLoading"
            >
                {{ modal.isEdit ? '保存' : '创建' }}
            </Button>
        </div>
    </Modal>
</template>
<script>
import { statusFormat } from "@/libs/baseModelFormat";
import { createCompany, updateCompany } from "@/api/modules/system-management/company-management.js";

export default {
    name: 'CompanyModal',
    data() {
        return {
            modal: {
                visible: false,
                isEdit: false,
                submitLoading: false,
                form: {
                    id: null,
                    name: '',
                    code: '',
                    status: false
                },
                rules: {
                    name: [
                        { required: true, message: '公司名称不能为空', trigger: 'blur' },
                        { type: 'string', min: 2, max: 100, message: '公司名称长度为2-100个字符', trigger: 'blur' }
                    ]
                }
            }
        };
    },
    computed: {
        modalTitle() {
            return this.modal.isEdit ? '编辑公司' : '新增公司';
        },
        statusOptions() {
            return [
                { label: true, text: '启用', icon: 'ios-checkmark-circle', color: '#19be6b' },
                { label: false, text: '禁用', icon: 'ios-close-circle', color: '#ed4014' }
            ];
        }
    },
    methods: {
        showModal(row = null) {
            this.resetForm();
            this.modal.visible = true;

            // 重置表单验证状态
            this.$nextTick(() => {
                if (this.$refs.companyForm) {
                    this.$refs.companyForm.resetFields();
                }

                if (row && row.id) {
                    console.log("row2", row);
                    const { id, code, name, status } = row;
                    this.modal.isEdit = true;
                    this.modal.form.id = id;
                    this.modal.form.code = code;
                    this.modal.form.name = name;
                    this.modal.form.status = status ? '1' : '0';
                    console.log("form:", this.modal.form);
                }
                else {
                    this.modal.isEdit = false;
                    this.modal.form.status = '1'; // 默认启用
                }
            });
        },
        
        resetForm() {
            this.modal.form = {
                id: null,
                name: '',
                code: '',
                status: '1'
            };
            this.modal.submitLoading = false;
        },
        
        validateForm() {
            return new Promise((resolve) => {
                this.$refs.companyForm.validate((valid) => {
                    resolve(valid);
                });
            });
        },
        
        async handleModalOk() {
            try {
                const isValid = await this.validateForm();
                if (!isValid) {
                    this.$Message.warning('请检查表单填写是否正确');
                    return;
                }

                this.modal.submitLoading = true;
                const formData = { ...this.modal.form };
                // 将字符串值转换为布尔值用于提交
                formData.status = formData.status === '1';
                
                let response;
                if (this.modal.isEdit) {
                    response = await updateCompany(formData);
                }
                else {
                    response = await createCompany(formData);
                }
                
                if (response && response.code === 0) {
                    this.$Message.success(this.modal.isEdit ? '更新成功' : '创建成功');
                    this.$emit('refresh');
                    this.modal.visible = false;
                }
                else {
                    this.$Message.error(response.msg==null || '操作失败，请重试');
                }
            }
            catch (error) {
                console.error('保存公司信息失败:', error);
                this.$Message.error('网络错误，请稍后重试');
            }
            finally {
                this.modal.submitLoading = false;
            }
        },
        
        handleModalCancel() {
            this.modal.visible = false;
        }
    }
};
</script>

<style lang="less" scoped>
.form-section {
    margin-bottom: 24px;
    padding: 16px;
    background: linear-gradient(135deg, rgba(45, 140, 240, 0.02) 0%, rgba(25, 190, 107, 0.02) 100%);
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.05);
    
    &:last-child {
        margin-bottom: 0;
    }

    .section-title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        font-weight: 600;
        color: #2c3e50;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 0.5px;

        span {
            margin-left: 8px;
        }
    }
}

/deep/ .ivu-modal-body {
    padding: 24px;
    max-height: 70vh;
    overflow-y: auto;
    
    &::-webkit-scrollbar {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
}

/deep/ .ivu-modal-header {
    border-bottom: 1px solid #e8e8e8;
    padding: 16px 24px;
    
    .ivu-modal-header-inner {
        font-size: 16px;
        font-weight: 600;
        color: #2c3e50;
    }
}

/deep/ .ivu-modal-footer {
    border-top: 1px solid #e8e8e8;
    padding: 16px 24px;
    text-align: right;
}

/deep/ .ivu-form-item {
    margin-bottom: 16px;
    
    .ivu-form-item-label {
        font-weight: 500;
        color: #606266;
        font-size: 14px;
        line-height: 1.6;
    }
}

/deep/ .ivu-input-wrapper {
    width: 100%;
    
    .ivu-input {
        transition: all 0.3s ease;
        border-radius: 6px;
        
        &:hover {
            border-color: #57a3f3;
        }
        
        &:focus {
            border-color: #57a3f3;
            box-shadow: 0 0 0 2px rgba(87, 163, 243, 0.2);
        }
    }
    
    .ivu-input-prefix {
        left: 12px;
        color: #c0c4cc;
    }
    
    .ivu-input {
        padding-left: 32px;
    }
}

/deep/ .ivu-select {
    width: 100%;
    
    .ivu-select-selection {
        border-radius: 6px;
        transition: all 0.3s ease;
        
        &:hover {
            border-color: #57a3f3;
        }
        
        &.ivu-select-focus {
            border-color: #57a3f3;
            box-shadow: 0 0 0 2px rgba(87, 163, 243, 0.2);
        }
    }
}

/deep/ .ivu-radio-group-button {
    .ivu-radio-wrapper {
        min-width: 80px;
        text-align: center;
        border-radius: 6px;
        transition: all 0.3s ease;
        
        &:hover {
            color: #2d8cf0;
        }
        
        &.ivu-radio-wrapper-checked {
            background: #2d8cf0;
            border-color: #2d8cf0;
            color: #fff;
            box-shadow: 0 2px 8px rgba(45, 140, 240, 0.3);
        }
    }
}

/deep/ .ivu-form-item-error {
    .ivu-input {
        border-color: #f56c6c;
        
        &:focus {
            box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.2);
        }
    }
    
    .ivu-select-selection {
        border-color: #f56c6c;
        
        &.ivu-select-focus {
            box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.2);
        }
    }
}

/deep/ .ivu-input-word-count {
    position: absolute;
    right: 8px;
    bottom: 1px;
    color: #c0c4cc;
    font-size: 12px;
    background: transparent;
}

/deep/ .ivu-btn {
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.3s ease;
    
    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }
    
    &:active {
        transform: translateY(0);
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    }
}

/deep/ .ivu-btn-primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    
    &:hover {
        background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
    }
}

/deep/ .ivu-textarea {
    border-radius: 6px;
    
    .ivu-input {
        resize: vertical;
        min-height: 80px;
    }
    
    &:hover .ivu-input {
        border-color: #57a3f3;
    }
    
    &.ivu-input-focus .ivu-input {
        border-color: #57a3f3;
        box-shadow: 0 0 0 2px rgba(87, 163, 243, 0.2);
    }
}

// 响应式设计
@media (max-width: 768px) {
    .form-section {
        margin-bottom: 16px;
        padding: 12px;
    }
    
    /deep/ .ivu-modal-body {
        padding: 16px;
    }
    
    /deep/ .ivu-modal-footer {
        padding: 12px 16px;
        
        .ivu-btn {
            font-size: 12px;
            padding: 6px 12px;
        }
    }
    
    .section-title {
        font-size: 13px;
    }
}
</style>